export default "__VITE_ASSET__6G$wusSd__"